import { CardData, Root } from './ProductCard.ui';

export const ProductCard = ({
  logo,
  name,
  amount,
}: {
  logo?: React.ReactNode;
  name: string;
  amount?: string;
}) => (
  <Root>
    {logo}
    <CardData>
      {name}, {amount}
    </CardData>
  </Root>
);
